export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">关于我们</h2>
          <p className="mt-3 text-sm text-foreground-600">了解韩国漫画平台的初心与愿景</p>

          <div className="mt-8 text-left bg-background-100 rounded-lg p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              韩国漫画是一个专注于韩国漫画（Korean Manhwa）内容发现与推荐的在线阅读平台。
              我们致力于为广大漫画爱好者提供<strong>好看的韩国漫画推荐</strong>、精准的<strong>韩国漫画排行榜</strong>以及涵盖热门题材的
              <strong>好看的韩国漫画大全</strong>，让每一位读者都能轻松找到心仪的作品。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-4">
              团队由一群资深漫画迷组成，每日追踪韩国漫画最新连载动态，精心筛选<strong>免费韩国漫画</strong>、
              <strong>韩国漫画高分推荐</strong>与<strong>韩国漫画必看</strong>佳作。
              无论是浪漫恋爱、奇幻冒险、热血动作还是悬疑惊悚题材，都能在我们的<strong>韩国漫画人气榜</strong>中找到值得一读的好作品。
              坚持纯粹、安全、无广告干扰的阅读推荐体验，是本站始终不变的承诺。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-4">
              未来我们将持续扩大收录范围，优化<strong>韩国漫画在线看</strong>体验，并与更多优质内容方合作，
              打造国内最值得信赖的韩国漫画发现入口。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}